import { Injectable, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthorizationGuard {
  private authService = inject(AuthService);

  public canActivate(): boolean {
    return this.authService.checkAuth();
  }
}
